class OBTODifferenceCheckerController {
    constructor($scope, $window, $timeout, $compile, pageService, $http, $routeParams, $rootScope, $location, ribbon, $uibModal, API, $localstorage, $log, $anchorScroll, OB, $route, $document) {
        this.$scope = $scope;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$compile = $compile;
        this.pageService = pageService;
        this.$http = $http;
        this.$routeParams = $routeParams;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.ribbon = ribbon;
        this.$uibModal = $uibModal;
        this.API = API;
        this.$localstorage = $localstorage;
        this.$log = $log;
        this.$anchorScroll = $anchorScroll;
        this.OB = OB;
        this.$route = $route;
        this.$document = $document;
        this.editor = null;
        this.content = null;
        this.remoteContent = null;

        // Bind methods to the class instance
        this.render = this.render.bind(this);
        this.override = this.override.bind(this);
        this.maximize = this.maximize.bind(this);
        this.minimize = this.minimize.bind(this);
        this.refresh = this.refresh.bind(this);
        this.format = this.format.bind(this);
        this.foldAll = this.foldAll.bind(this);
        this.unfold = this.unfold.bind(this);
    }

    async render() {
        try {
            if (this.editor) {
                this.editor.dispose();
            }
        } catch (e) {}

        setTimeout(async () => {
            const monaco = await import('monaco-editor');
            const originalModel = monaco.editor.createModel(this.remoteContentRef, "text/plain");
            const modifiedModel = monaco.editor.createModel(this.contentref, "text/plain");
            this.editor = monaco.editor.createDiffEditor(document.getElementById("container"));

            this.editor.setModel({
                original: originalModel,
                modified: modifiedModel
            });

            const navi = monaco.editor.createDiffNavigator(this.editor, {
                followsCaret: true,
                ignoreCharChanges: true
            });

            this.$timeout(() => {
                this.$rootScope.$emit("event.render.subform.completed");
            }, 500);
        }, 100);
    }

    async override() {
        const swal = await import('sweetalert2');
        swal.default({
            title: "Are you sure?",
            text: "You gotta do what you gotta do",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, override it!",
            cancelButtonText: "No, cancel plz!"
        }).then((result) => {
            if (result.value) {
                this.ngModel.$setViewValue(this.editor.getModel().original.getValue());
                this.submitForm();
                swal.default("Success", "Changes have been saved", "success");
            } else {
                swal.default("Cancelled", "Very close, but nothing to worry about now!", "error");
            }
        });
    }

    maximize() {
        this.editorView = {
            'position': 'fixed',
            'width': '100%',
            'top': '50px',
            'left': '0',
            'z-index': '2001',
            'height': '96%'
        };
        this.controlsDistractionFree = {
            'position': 'fixed',
            'top': '0',
            'left': '0',
            'z-index': '1000',
            'width': '100%',
            'height': '50px'
        };
        this.render();
    }

    minimize() {
        this.editorView = {'height': '700px'};
        this.controlsDistractionFree = {};
        this.outputView = {'height': '700px'};
        this.render();
    }

    refresh() {
        this.render();
    }

    format() {
        this.editor.trigger('anyString', 'editor.action.formatDocument');
    }

    foldAll() {
        this.editor.trigger('fold', 'editor.foldAll');
    }

    unfold() {
        this.editor.trigger('unfold', 'editor.unfoldAll');
    }

    async $onInit() {
        const feather = await import("feather-icons");
        feather.replace({
            width: 18,
            height: 18,
        });

        this.editorView = {'height': '700px', 'width': '100%'};
        this.render();
    }
}

OBTODifferenceCheckerController.$inject = [
    '$scope',
    '$window',
    '$timeout',
    '$compile',
    'pageService',
    '$http',
    '$routeParams',
    '$rootScope',
    '$location',
    'ribbon',
    '$uibModal',
    'API',
    '$localstorage',
    '$log',
    '$anchorScroll',
    'OB',
    '$route',
    '$document'
];

const ObtoComponentDifferenceChecker = {
    selector: "obtoDifferenceChecker",
    templateUrl: ['$rootScope', ($rootScope) => {
        return $rootScope.viewFiles + '/difference.html';
    }],
    require: {
        ngModel: '^ngModel'
    },
    bindings: {
        contentref: '=',
        remoteContentRef: '=',
        submitForm: '&'
    },
    controller: ['$scope', '$window', '$timeout', '$compile', 'pageService', '$http', '$routeParams', '$rootScope', '$location', 'ribbon', '$uibModal', 'API', '$localstorage', '$log', '$anchorScroll', 'OB', '$route', '$document', OBTODifferenceCheckerController]
};

export default ObtoComponentDifferenceChecker;